import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-282b2139"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "search-body" }
const _hoisted_3 = {
  key: 0,
  class: "wrapper-card"
}
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center mt-16" }
const _hoisted_6 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_7 = { class: "search-body" }
const _hoisted_8 = {
  key: 0,
  class: "wrapper-card"
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center mt-16" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Create Account ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_registration_doctor_card = _resolveComponent("registration-doctor-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.dataRequest)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: "Searching for your detailed information"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.doctors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors, (doctor) => {
                  return (_openBlock(), _createBlock(_component_registration_doctor_card, {
                    doctor: doctor,
                    key: doctor.npi,
                    "selected-doctor": _ctx.selectedDoctor?.npi,
                    onOnSelect: _ctx.handleSelect
                  }, null, 8, ["doctor", "selected-doctor", "onOnSelect"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "step-4a",
              class: "router-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.step4.find.name')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: _ctx.skipNpiUrl,
              class: "router-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.npi.no.npi')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(_component_app_button, {
            onClick: _withModifiers(_ctx.nextStep, ["prevent"]),
            type: "primary",
            class: "w-100 el-button-lg",
            disabled: !_ctx.selectedDoctor,
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('registration.find.name.button')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        (_ctx.dataRequest)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: "Searching for your detailed information"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.doctors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors, (doctor) => {
                  return (_openBlock(), _createBlock(_component_registration_doctor_card, {
                    doctor: doctor,
                    key: doctor.npi,
                    "selected-doctor": _ctx.selectedDoctor?.npi,
                    onOnSelect: _ctx.handleSelect
                  }, null, 8, ["doctor", "selected-doctor", "onOnSelect"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "step-4a",
              class: "router-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.cant.find.you')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: _ctx.skipNpiUrl,
              class: "router-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.npi.no.npi')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(_component_app_button, {
            onClick: _withModifiers(_ctx.nextStep, ["prevent"]),
            type: "primary",
            class: "w-100 el-button-lg",
            disabled: !_ctx.selectedDoctor,
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]))
}